'use client';

import React from "react";
import Drawer from "./Drawer";
import Image from "next/image";

import type { NavbarLink, NavbarAction, SubDrawer } from "../navbarData";

type Props = {
  links: NavbarLink[];
  actions: NavbarAction[];
  subDrawers: Record<string, SubDrawer>;
  open: boolean;
  toggleDrawer: () => void;
  closeDrawer: () => void;
  openSubDrawer: (id: string) => void;
  closeSubDrawer: () => void;
  activeSubDrawer: string | null;
};

export default function MobileNavbar({
  links,
  actions,
  subDrawers,
  open,
  toggleDrawer,
  closeDrawer,
  openSubDrawer,
  closeSubDrawer,
  activeSubDrawer,
}: Props) {
  return (
    <>
      <button
        className="navbar__hamburger inline-flex items-center justify-center w-8 h-8 bg-transparent border-none cursor-pointer p-0 outline-none"
        aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
        aria-expanded={open}
        onClick={toggleDrawer}
      >
        <Image
          src="/assets/icons/menu-burger.svg"
          alt="Menu"
          title="Menu"
          width={32}
          height={32}
          className={`transition-opacity duration-200 ${open ? 'opacity-0' : 'opacity-100'}`}
        />
      </button>

      <Drawer
        open={open}
        links={links}
        actions={actions}
        subDrawers={subDrawers}
        activeSubDrawer={activeSubDrawer}
        onClose={closeDrawer}
        onOpenSubDrawer={openSubDrawer}
        onCloseSubDrawer={closeSubDrawer}
      />
    </>
  );
}